import { Link } from 'react-router-dom';
import { Button } from '../common/Button';
import ProfileAvatar from '../common/ProfileAvatar';
import { useTranslation } from 'react-i18next';
import { useProfileRole } from '../../hooks/useProfileRole';

export const AccountCard = ({
  firstName,
  lastName,
  avatarUrl,
  onNavigate,
  onLogout,
}: {
  firstName?: string;
  lastName?: string;
  avatarUrl?: string;
  onNavigate: () => void;
  onLogout: () => void;
}) => {
  const { t } = useTranslation('common');
  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`;

  const { isAdmin } = useProfileRole();

  return (
    <section className="mb-6">
      <div className="text-xs text-white mb-2 font-bold">{t('accountCard.title')}</div>
      <div className="bg-white rounded-3xl p-6 flex flex-col items-center">
        <div className="flex items-center justify-between w-full">
          <div className="text-secondary text-2xl">{firstName}</div>
          <ProfileAvatar
            first_name={firstName ?? ''}
            avatar_url={avatarUrl}
            initials={initials}
            className="h-20 w-20 text-3xl"
          />
        </div>
        {isAdmin ? (
          <Link
            to="admin/settings"
            onClick={() => onNavigate()}
            className="w-full text-xl text-center text-secondary font-bold mt-6 py-2"
          >
            {t('accountCard.settings')}
          </Link>
        ) : (
          <Link
            to="/settings"
            onClick={() => onNavigate()}
            className="w-full text-xl text-center text-secondary font-bold mt-6 py-2"
          >
            {t('accountCard.settings')}
          </Link>
        )}
        {!isAdmin && (
          <>
            <Link
              to="/wallet"
              onClick={() => onNavigate()}
              className="w-full text-xl text-center text-secondary font-bold mt-6 py-2"
            >
              {t('accountCard.wallet')}
            </Link>
            <Link
              to="/payment"
              onClick={() => onNavigate()}
              className="w-full text-xl text-center text-secondary font-bold mt-6 py-2"
            >
              {t('accountCard.payment')}
            </Link>
          </>
        )}
        <Button variant="primary" className="w-full rounded-full mt-6" onClick={onLogout}>
          {t('accountCard.signOut')}
        </Button>
      </div>
    </section>
  );
};
